module.exports = __webpack_public_path__ + "img/R8802-PX.783b4434.jpg";